import http from './http.service';

class PriceService {
    constructor() {
        if (PriceService.instance) {
            return PriceService.instance;
        }

        PriceService.instance = this;
    }

    update(priceId, data) {
        return http.put(`/price/${priceId}/update`, data).then(res => res.data);
    }
}

export default new PriceService();
